import { Box, Text } from '@mantine/core'

import { CollapsibleContentSection } from '@/components/CollapsibleContentSection'
import { Table } from '@/components/Table'
import type { GetFAQsResponse } from '@/services/api/api.types'
import type { TableColumnDef } from '@/utils/table'
import { createTableColumnHelper } from '@/utils/table'

import { useContentModuleScreenData } from './ContentModuleScreen'

export function ModuleFAQSection() {
  const data = useContentModuleScreenData()

  return (
    <CollapsibleContentSection
      defaultCollapsed
      id="module-faqs"
      title="Module FAQs"
      subtitle="Frequently asked questions about this module."
      ContentElement={<FAQSectionTable data={data.cmQuery.data?.faqs ?? []} />}
    />
  )
}

export function FAQSectionTable(props: { data: GetFAQsResponse | null }) {
  if (!props.data?.length) {
    return <Text c="dimmed">No FAQs Added</Text>
  }

  return (
    <Table
      enableTableHead={false}
      enableTopToolbar={false}
      data={props.data}
      columns={faqCols}
      highlightOnHover={false}
    />
  )
}

const columnHelper = createTableColumnHelper<GetFAQsResponse[0]>()
const faqCols: TableColumnDef<GetFAQsResponse[0]>[] = [
  columnHelper.display({
    id: 'faq',
    header: 'FAQ',
    cell: props => {
      return (
        <Box>
          <Text size="sm" fw={500} style={{ whiteSpace: 'pre-wrap' }}>
            {props.row.original.question}
          </Text>
          <Text size="sm" c="dimmed" style={{ whiteSpace: 'pre-wrap' }}>
            {props.row.original.answer}
          </Text>
        </Box>
      )
    },
  }),
]
